// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Singapore from '../_raw/flag/icon_flag_singapore.png';

export default () => <img src={Singapore} alt="Singapore" />;
